import { Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core';
import { FormGroup } from '@maplix/forms';
import { BASELAYERS, IBaseLayerPlaceholder, ILegendUrl } from '@maplix/maps';
import { IMapDataLayer, IMapResult, ISurveyImage, ISurveyMap, MapType } from '@maplix/utils';

@Component({
  selector: 'maplix-map-sidebar',
  templateUrl: './map-sidebar.component.html',
  styleUrls: ['./map-sidebar.component.scss'],
})
export class MapSidebarComponent {
  @Input()
  public activeMap: IMapResult;

  @Input()
  public activeTab: string = 'legend';

  @Input()
  public mapForm: FormGroup<IMapResult | ISurveyMap | ISurveyImage>;

  @Input()
  public readonly mapType: MapType;

  @Input()
  public readonly wmsLegends: ILegendUrl[];

  @Input()
  public readonly language: string;

  @Input()
  public readonly editable: boolean;

  @Input()
  public readonly sidebarTitle: string = 'Layers';

  @Output()
  private changeLayerOrder: EventEmitter<void> = new EventEmitter();

  @Output()
  private toggleVisibility: EventEmitter<FormGroup<IMapDataLayer>> = new EventEmitter();

  @Output()
  private onDelete: EventEmitter<any> = new EventEmitter();

  @Output()
  private onZoom: EventEmitter<any> = new EventEmitter();

  @Output()
  private open: EventEmitter<{
    type: string;
    layer?: FormGroup<IMapDataLayer>;
  }> = new EventEmitter();

  @Output()
  private openCloud: EventEmitter<void> = new EventEmitter();

  @Output()
  public close: EventEmitter<void> = new EventEmitter();

  @Output()
  private toggleHidden: EventEmitter<{
    showOnLegend: boolean;
    layer?: FormGroup<IMapDataLayer>;
  }> = new EventEmitter();

  @Output()
  private setBaseLayer: EventEmitter<string> = new EventEmitter();

  @Output()
  private copyToClipboard: EventEmitter<string> = new EventEmitter();

  public baseLayers: IBaseLayerPlaceholder[] = BASELAYERS;

  public get mapUrl(): string {
    return this.activeMap ? `${this.environment.apps.mapShortcut}${this.language}/${this.activeMap.uri}` : '';
  }

  constructor(@Inject('environment') private environment: any) {}

  public onCloseSidebar() {
    this.close.emit();
  }

  public onChangeVisibility(layer: FormGroup<IMapDataLayer>) {
    this.toggleVisibility.emit(layer);
  }

  public onZoomToLayer(layer) {
    this.onZoom.emit(layer);
  }

  public onOpenLayerModal($event) {
    this.open.emit($event);
  }

  public onOpenCloudModal() {
    this.openCloud.emit();
  }

  public onToggleHidden($event) {
    this.toggleHidden.emit($event);
  }

  public onChangeLayerOrder() {
    this.changeLayerOrder.emit();
  }

  public onDeleteLayer(layer: IMapDataLayer) {
    this.onDelete.emit(layer);
  }

  public onSetBaseLayer(layer: string) {
    this.setBaseLayer.emit(layer);
  }

  public onCopyToClipboard(text: string) {
    navigator.clipboard.writeText(text);
    this.copyToClipboard.emit('map.socials.url.COPYSUCCESS');
  }
}
